export default __webpack_public_path__ + "static/media/skull-on.3304636b.svg";